// extracted by mini-css-extract-plugin
export var item = "Tags-module--item--52015";
export var list = "Tags-module--list--82ae6";
export var tags = "Tags-module--tags--18589";